// // import React, { useEffect, useState } from 'react';
// // import { Navbar, Nav, Container, Button } from 'react-bootstrap';
// // import './Navbar.css';
// // import { useNavigate } from 'react-router-dom';
// // import { supabase } from '../../supabaseClient';
// // import { FiLogOut } from 'react-icons/fi'; // Logout icon

// // const NavBar = () => {
// //   const navigate = useNavigate();
// //   const [user, setUser] = useState(null);

// //   useEffect(() => {
// //     // Get current user on load
// //     supabase.auth.getUser().then(({ data }) => {
// //       setUser(data.user);
// //     });

// //     // Listen for login/logout events
// //     const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
// //       setUser(session?.user || null);
// //     });

// //     return () => {
// //       listener.subscription.unsubscribe();
// //     };
// //   }, []);

// //   const handleStartScan = () => {
// //     if (user) {
// //       navigate('/scanner');
// //     } else {
// //       navigate('/auth');
// //     }
// //   };

// //   const handleLogout = async () => {
// //     await supabase.auth.signOut();
// //     setUser(null);
// //     navigate('/');
// //   };

// //   return (
// //     <Navbar expand="lg" variant="dark" className="ai-navbar sticky-top">
// //       <Container>
// //         <Navbar.Brand href="/">
// //           <img
// //             src="./logo192.png"
// //             alt="AI Visibility"
// //             width="40"
// //             height="40"
// //             className="d-inline-block align-top me-2"
// //           />
// //           <span className="ai-navbar-brand-text">AI Visibility</span>
// //         </Navbar.Brand>

// //         <Navbar.Toggle aria-controls="main-navbar" />

// //         <Navbar.Collapse id="main-navbar">
// //           <Nav className="ms-auto align-items-center">
// //             <Nav.Link href="/#why">Why This Matters</Nav.Link>
// //             <Nav.Link href="/#pricing-plans">Pricing</Nav.Link>
// //             <Nav.Link href="/#contact">Contact</Nav.Link>

// //             <Button
// //               variant="light"
// //               size="sm"
// //               className="ms-3 ai-navbar-button"
// //               onClick={handleStartScan}
// //             >
// //               Start Free Scan
// //             </Button>

// //             {user && (
// //               <Button
// //                 variant="outline-light"
// //                 size="sm"
// //                 className="ms-2 text-center"
// //                 style={{
// //                   "border-radius": "100%",
// //                   "width":"35px",
// //                   "height":"35px"
// //                 }}
// //                 onClick={handleLogout}
// //                 title="Logout"
// //               >
// //                 <FiLogOut />
// //               </Button>
// //             )}
// //           </Nav>
// //         </Navbar.Collapse>
// //       </Container>
// //     </Navbar>
// //   );
// // };

// // export default NavBar;

// import React, { useEffect, useState } from 'react';
// import { Navbar, Nav, Container, Button, Dropdown, Image } from 'react-bootstrap';
// import './Navbar.css';
// import { useNavigate } from 'react-router-dom';
// import { supabase } from '../../supabaseClient';
// import { FiUser, FiLogOut, FiClock, FiUserCheck } from 'react-icons/fi';

// const NavBar = () => {
//   const navigate = useNavigate();
//   const [user, setUser] = useState(null);

//   useEffect(() => {
//     // Get current user on load
//     supabase.auth.getUser().then(({ data }) => {
//       setUser(data.user);
//     });

//     // Listen for login/logout events
//     const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
//       setUser(session?.user || null);
//     });

//     return () => {
//       listener.subscription.unsubscribe();
//     };
//   }, []);

//   const handleStartScan = () => {
//     if (user) {
//       navigate('/scanner');
//     } else {
//       navigate('/auth');
//     }
//   };

//   const handleLogout = async () => {
//     await supabase.auth.signOut();
//     setUser(null);
//     navigate('/auth');
//   };

//   const handleHistory = () => {
//     navigate('/history');
//   };

//   const handleAccount = () => {
//     navigate('/account'); // Optional: create an account page if needed
//   };

//   return (
//     <Navbar expand="lg" variant="dark" className="ai-navbar sticky-top">
//       <Container>
//         <Navbar.Brand href="/">
//           <img
//             src="./logo192.png"
//             alt="AI Visibility"
//             width="40"
//             height="40"
//             className="d-inline-block align-top me-2"
//           />
//           <span className="ai-navbar-brand-text">AI Visibility</span>
//         </Navbar.Brand>

//         <Navbar.Toggle aria-controls="main-navbar" />

//         <Navbar.Collapse id="main-navbar">
//           <Nav className="ms-auto align-items-center">
//             <Nav.Link href="/#why">Why This Matters</Nav.Link>
//             <Nav.Link href="/#pricing-plans">Pricing</Nav.Link>
//             <Nav.Link href="/#contact">Contact</Nav.Link>

//             <Button
//               variant="light"
//               size="sm"
//               className="ms-3 ai-navbar-button"
//               onClick={handleStartScan}
//             >
//               Start Free Scan
//             </Button>

//             {user && (
//               <Dropdown align="end" className="ms-3">
//                 <Dropdown.Toggle variant="outline-light" size="sm" className="d-flex align-items-center" style={{ borderRadius: '50%', width: '40px', height: '40px', padding: '0' }}>
//                   <FiUser size={20} />
//                 </Dropdown.Toggle>

//                 <Dropdown.Menu>
//                   <Dropdown.Item onClick={handleHistory}>
//                     <FiClock className="me-2" />
//                     Scan History
//                   </Dropdown.Item>

//                   <Dropdown.Item onClick={handleAccount}>
//                     <FiUserCheck className="me-2" />
//                     My Account
//                   </Dropdown.Item>

//                   <Dropdown.Divider />

//                   <Dropdown.Item onClick={handleLogout}>
//                     <FiLogOut className="me-2" />
//                     Logout
//                   </Dropdown.Item>
//                 </Dropdown.Menu>
//               </Dropdown>
//             )}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// };

// export default NavBar;

import { useEffect, useState } from "react";
import { Navbar, Nav, Container, Dropdown, Badge } from "react-bootstrap";
import "./Navbar.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  supabase,
  getSafeSession,
  getCachedSession,
  getCachedProfile,
  setCachedProfile,
  clearCachedProfile,
  clearSupabaseAuthStorage,
} from "../../supabaseClient";
import {
  FiUser,
  FiLogOut,
  FiClock,
  FiUserCheck,
  FiSun,
  FiMoon,
  FiGrid,
  FiShield,
} from "react-icons/fi";

const NAV_LINKS = [
  { label: "About Us", href: "https://seenbyai.ai/about-us/" },
  { label: "Additional Services", href: "https://seenbyai.ai/services/" },
  { label: "Blogs", href: "https://seenbyai.ai/blog/" },
  { label: "FAQ", href: "https://seenbyai.ai/faq/" },
  { label: "Contact Us", href: "https://seenbyai.ai/contact/" },
];

const NavBar = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(() => getCachedSession()?.user || null);
  const [userProfile, setUserProfile] = useState(() => {
    const s = getCachedSession();
    return s?.user?.id ? getCachedProfile(s.user.id) : null;
  });
  const isAdmin = !!(
    userProfile?.is_admin ||
    user?.user_metadata?.is_admin ||
    user?.app_metadata?.is_admin
  );
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(
    () => localStorage.getItem("theme") !== "light", // persist preference
  );

  // ✅ useEffect #1 — theme toggle
  useEffect(() => {
    const theme = darkMode ? "dark" : "light";
    document.body.classList.toggle("light-mode", !darkMode);
    document.documentElement.setAttribute("data-theme", theme);
    localStorage.setItem("theme", theme);
  }, [darkMode]);

  // ✅ useEffect #2 — auth + profile
  useEffect(() => {
    // Instantly check cache to avoid unlogged-in flash
    const cachedSession = getCachedSession();
    if (cachedSession?.user) {
      setUser(cachedSession.user);
    }

    const fetchUserData = async () => {
      try {
        let session = getCachedSession();
        const isCachedExpired = session?.expires_at
          ? session.expires_at < Math.floor(Date.now() / 1000)
          : true;

        if (!session || isCachedExpired) {
          try {
            const result = await getSafeSession(15000);
            if (result.data?.session) {
              session = result.data.session;
            }
          } catch (err) {
            console.error("Navbar: getSafeSession failed:", err);
          }
        }

        const currentUser = session?.user || null;
        setUser(currentUser);

        if (currentUser && session?.access_token) {
          let resolvedProfile = null;
          try {
            // Try backend first
            try {
              const profileRes = await axios.get(
                `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/user/profile`,
                {
                  headers: { Authorization: `Bearer ${session.access_token}` },
                  timeout: 10000,
                }
              );
              if (profileRes.data) {
                resolvedProfile = {
                  plan: profileRes.data.plan,
                  scans_used: profileRes.data.scans_used,
                  is_admin: profileRes.data.is_admin,
                };
              }
            } catch (backendErr) {
              console.warn("Navbar: Backend profile fetch failed, falling back to Supabase client:", backendErr);
              const { data: profiles, error } = await Promise.race([
                supabase
                  .from("profiles")
                  .select("plan, scans_used, is_admin")
                  .eq("id", currentUser.id),
                new Promise((_, reject) => setTimeout(() => reject(new Error("Supabase profile fetch timed out")), 10000))
              ]);
              if (!error && profiles && profiles.length > 0) {
                resolvedProfile = profiles[0];
              }
            }
          } catch (err) {
            console.warn("Navbar: Profile fetch fallback warning:", err);
          }
          if (resolvedProfile) {
            setUserProfile(resolvedProfile);
            setCachedProfile(currentUser.id, resolvedProfile);
          }
        }
      } catch (err) {
        console.warn("Navbar fetchUserData error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        setTimeout(async () => {
          if (event === "SIGNED_OUT") {
            setUser(null);
            setUserProfile(null);
            clearCachedProfile();
          } else if (event === "SIGNED_IN" && session) {
            const currentUser = session.user || null;
            setUser(currentUser);
            if (currentUser) {
              const cached = getCachedProfile(currentUser.id);
              if (cached) {
                setUserProfile(cached);
              }
              let resolvedProfile = null;
              try {
                const { data: profiles, error } = await Promise.race([
                  supabase
                    .from("profiles")
                    .select("plan, scans_used, is_admin")
                    .eq("id", currentUser.id),
                  new Promise((_, reject) => setTimeout(() => reject(new Error("Supabase profile fetch timed out")), 10000))
                ]);
                if (!error && profiles && profiles.length > 0) {
                  resolvedProfile = profiles[0];
                } else {
                  const profileRes = await axios.get(
                    `${process.env.REACT_APP_API_URL || "http://localhost:8000"}/user/profile`,
                    {
                      headers: { Authorization: `Bearer ${session.access_token}` },
                      timeout: 10000,
                    }
                  );
                  if (profileRes.data) {
                    resolvedProfile = {
                      plan: profileRes.data.plan,
                      scans_used: profileRes.data.scans_used,
                      is_admin: profileRes.data.is_admin,
                    };
                  }
                }
              } catch (err) {
                console.warn("Navbar onAuthStateChange profile fetch fallback warning:", err);
              }
              if (resolvedProfile) {
                setUserProfile(resolvedProfile);
                setCachedProfile(currentUser.id, resolvedProfile);
              }
            }
          } else if (event === "TOKEN_REFRESHED" && session) {
            // Update user state without DB queries to prevent deadlocks
            setUser(session.user || null);
          }
        }, 0);
      },
    );

    return () => listener.subscription.unsubscribe();
  }, []);



  const getRemainingScans = () => {
    if (!userProfile) return 0;
    const plan = (userProfile.plan || 'guest').toLowerCase();
    if (plan === 'expansion' || plan === 'business' || userProfile.is_admin) return Infinity;
    const maxScans = { core: 1, growth: 20, pro: 20, guest: 1 }[plan] || 0;
    return Math.max(0, maxScans - (userProfile.scans_used || 0));
  };

  const handleScanClick = () => {
    if (user) {
      navigate(
        userProfile && getRemainingScans() <= 0 && !userProfile.is_admin ? "/pricing" : "/scanner",
      );
    } else {
      navigate("/scanner");
    }
  };


  const handleLogout = async () => {
    try {
      // Non-blocking signout call with 500ms timeout so API latency never freezes UI
      await Promise.race([
        supabase.auth.signOut(),
        new Promise((resolve) => setTimeout(resolve, 500)),
      ]);
    } catch (err) {
      console.warn("Navbar: Error during signOut:", err);
    } finally {
      clearSupabaseAuthStorage();
      setUser(null);
      setUserProfile(null);
      window.location.href = "/auth";
    }
  };

  const scanBtnLabel = () => {
    if (loading) return "Loading...";
    if (!user) return "Free scan";
    if (userProfile && getRemainingScans() <= 0) return "Upgrade";
    return "Free scan";
  };

  return (
    <Navbar expand="lg" variant="dark" className="ai-navbar sticky-top">
      <Container>
        {/* Brand */}
        <Navbar.Brand
          href="https://seenbyai.ai/"
          className="navbar-brand-custom"
        >
          <img
            src="./logo.jpeg"
            alt="SeenByAI"
            className="navbar-logo dark-mode-logo"
          />
          <img
            src="./seenbyailogowbg.png"
            alt="SeenByAI"
            className="navbar-logo light-mode-logo"
          />
          {/* <span className="navbar-brand-name">SeenByAI</span> */}
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" />

        <Navbar.Collapse id="main-navbar">
          {/* Nav links — centred */}
          <Nav className="mx-auto">
            {NAV_LINKS.map(({ label, href }) => (
              <Nav.Link key={label} href={href}>
                {label}
              </Nav.Link>
            ))}
          </Nav>

          {/* Right side actions */}
          <div className="d-flex align-items-center gap-2">
            {/* Show plan badge + scans count when logged in */}
            {user && userProfile && (
              <>
                <Badge
                  className="ai-plan-badge"
                  bg={
                    userProfile.is_admin
                      ? "warning"
                      : userProfile.plan === "pro"
                        ? "primary"
                        : userProfile.plan === "business"
                          ? "success"
                          : "secondary"
                  }
                  text={userProfile.is_admin ? "dark" : "light"}
                >
                  {userProfile.is_admin ? "ADMIN" : userProfile.plan?.toUpperCase() || "GUEST"}
                </Badge>
                <span className="ai-scans-text">
                  {userProfile.is_admin || ['expansion', 'business'].includes((userProfile.plan || '').toLowerCase())
                    ? "Unlimited scans"
                    : `${getRemainingScans()}/${{ core: 1, growth: 20, pro: 20, guest: 1 }[(userProfile.plan || 'guest').toLowerCase()] || 0} scans`}
                </span>
              </>
            )}

            {/* Primary CTA */}
            <button
              className="ai-navbar-scan-btn"
              onClick={handleScanClick}
              disabled={loading}
            >
              {scanBtnLabel()}
            </button>

            {/* Theme toggle */}
            <button
              className="ai-theme-toggle"
              onClick={() => setDarkMode((d) => !d)}
              title={darkMode ? "Switch to light mode" : "Switch to dark mode"}
            >
              {darkMode ? <FiSun size={18} /> : <FiMoon size={18} />}
            </button>

            {/* Login button for unauthenticated users */}
            {!user && (
              <button
                className="ai-navbar-login-btn btn btn-sm fw-bold px-3 py-1 ms-1"
                onClick={() => navigate("/auth")}
              >
                Login
              </button>
            )}

            {/* User dropdown — only when logged in */}
            {user && (
              <Dropdown align="end">
                <Dropdown.Toggle as="button" className="ai-user-avatar-btn">
                  <FiUser size={17} />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate("/user-dashboard")}>
                    <FiGrid className="me-2" /> Dashboard
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/history")}>
                    <FiClock className="me-2" /> Scan History
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => navigate("/account")}>
                    <FiUserCheck className="me-2" /> My Account
                  </Dropdown.Item>
                  {isAdmin && (
                    <Dropdown.Item onClick={() => navigate("/master-admin")}>
                      <FiShield className="me-2" /> Master Admin
                    </Dropdown.Item>
                  )}
                  <Dropdown.Divider />
                  <Dropdown.Item onClick={handleLogout}>
                    <FiLogOut className="me-2" /> Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;